import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlumniModel } from 'common/models/page-models/Alumni-form/alumni-form-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AlumniFormWidgetService } from 'common/widget/alumni/alumni-form-widget.service';



@Injectable({
    providedIn: 'root'
})
export class AlumniResolver extends FormResolverService<AlumniModel> {
    constructor(
        protected fs: AlumniFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
 
  
    
}
